module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch1"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MAMA MARION’S "), _c('strong', [_vm._v("MANDELBROIDT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "floatleft"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img-015.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("MAKES 36 TO 48 COOKIES")]), _vm._v(" "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-014.jpg"
    }
  }), _vm._v(" I adore Three Brothers Bakery in Houston, not only because the family that owns it (and has for five generations) make dreamy pies and sweet breads, but also because, well, the place has soul. You can just feel it. Taste it. (What’s more, the family never gives out its recipes, so having this one is a real treat.) This "), _c('em', [_vm._v("mandelbroidt,")]), _vm._v(" essentially a nut biscotti, hails from owner Janice Jucker’s maternal great-grandmother, Chassi, who lived in Russia. Chassi died in a cellar while helping hide the czar’s men during ethnic violence in the early part of the twentieth century. And on Janice’s husband’s side of the family, close family hid from the Nazis under the floorboards of their home. The entire family fled religious persecution to come to America. And the success that’s followed just proves everything can’t be taken away from a family. Memories and traditions live on through recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('span', {
    staticClass: "cc"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MANDELBROIDT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 cups sifted all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("3")]), _vm._v(" cups packed light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup (2 sticks) unsalted butter, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cups chopped pecans, walnuts, or almonds, toasted (see "), _c('span', {
    attrs: {
      "href": "#/014chapter7#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 teaspoons almond extract")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('span', {
    staticClass: "cc"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEMISWEET CHOCOLATE GLAZE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1½ cups semisweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 tablespoons (¾ stick) unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons light corn syrup")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("TO MAKE THE MANDELBROIDT:")])])]), _vm._v(" Preheat the oven to 350°F.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(" a large bowl, stir together the flour, baking soda, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(" another large bowl, combine the sugar, butter, and eggs. Stir until smooth and add to the bowl of dry ingredients; mix well. Add the pecans, almond extract, and vanilla; mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("USING")])]), _vm._v(" floured hands (the dough will be sticky), roll the dough into three rounded logs, 2 to 3 inches wide, and bake on a parchment paper-lined baking sheet for 20 minutes. Remove from the oven and let cool for about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("REDUCE")])]), _vm._v(" the oven temperature to 325°F.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("USING")])]), _vm._v(" a serrated knife, slice each log into 1- or 1½-inch sections. Place them on a parchment paper-lined baking sheet. Bake in batches for 10 minutes or until the cookies are firm. Remove and let them cool on wire racks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("TO MAKE THE GLAZE:")])])]), _vm._v(" Put the chocolate chips, butter, and corn syrup in the top of a double boiler over hot (but not boiling) water. When the mixture is melted and smooth, stir in the vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("DIP")])]), _vm._v(" half of each cookie in the chocolate glaze and let them rest, until the chocolate is firm, before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space2"
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("NOTE:")])]), _vm._v(" The cookies can be frozen for up to 6 months, layered in an airtight container with wax paper.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "aa"
  }, [_vm._v("Divide and Conquer: Cookie Swaps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cookie swaps or exchanges are the potlucks of dessert roundups, cleverly created so that members of small or even large groups can bake and take one batch and, after the party, wind up with maybe a dozen different varieties to enjoy during the holiday season.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Galveston, the University of Texas Medical Branch has had twenty-five years of perfecting cookie swaps. Here’s how they make it work:")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-017a.jpg"
    }
  }), _vm._v(" Twenty people commit to each making ten dozen homemade cookies.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-017a.jpg"
    }
  }), _vm._v(" Each person then divides his or her cookies into twenty baggies of six, with the recipe affixed to each baggie.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-017a.jpg"
    }
  }), _vm._v(" One baggie is reserved for placing on the tasting table, where the cookies will be presented and discussed before being voted on for “best looking” and/or “best tasting.” * After the event, each person goes home with a half dozen samples of nineteen different cookies.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-017a.jpg"
    }
  }), _vm._v(" Collect the recipes: They can be published in a keepsake cookbook that might be sold to benefit a charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-space1"
  }, [_vm._v("Over the years the Galveston group has experienced sadness, like when one of their friends and fellow bakers died of leukemia. There’s also been joy when another baker, Mary Bass, was inspired to start her own cake-ball business (and now Viva la Cake Balls is going gangbusters).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through the decades, there have been hundreds of recipes enjoyed: pecan bars, chocolate macaroons, white chocolate chunk cookies, thumbprint cookies, gingersnaps, peanut brittle, and more. There have been traditional favorites, but also some ethnic varieties many might never be exposed to otherwise. "), _c('a', {
    attrs: {
      "href": "#/009chapter2#page_18"
    }
  }, [_vm._v("The Chocolate-Peanut Clusters")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/010chapter3#page_19"
    }
  }, [_vm._v("Cran-Pistachio Cookies")]), _vm._v(" are two of their recent offerings.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e395688c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008chapter1.vue
// module id = 78
// module chunks = 0